import webConfig from '@dts/shared/src/utils/httpUrlConfig';
import { dashboardApi } from '@/api/modules/dashboard';

export function isJson(str: any) {
  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
}

export const fileDownload = ({ url }: Record<string, string>) => {
  const alink = document.createElement('a');
  alink.href = url;
  alink.target = '_blank';
  alink.click();
  alink.remove();
};

export const openPdf = (letter: any, data: any) => {
  const { id, shareUrl: url } = letter;
  try {
    const openUrl = letter?.stores?.[1].url;
    if (openUrl) {
      window.open(openUrl, '_blank');
    } else {
      const name = url.substr(url.lastIndexOf('/') + 1);
      window.open(webConfig.apiUrl + '/dashboard/view/' + name, '_blank');
    }
  } catch {
    console.error('openPdf-->', openPdf);
  }
  dashboardApi.recordPageView({ ...(data ?? {}), pageId: id });
};

export const parseUrlQuery = (rawUrl: string) => {
  const url = new URL(rawUrl, window.location.origin);
  const query: Record<string, string> = {};
  url.searchParams.forEach((value, key) => {
    query[key] = value;
  });
  return {
    path: url.pathname,
    query,
  };
};

export const sendEmail = (email: string, recordReq?: defs.dtsServer.DtsActionBrowseHistoryVo) => {
  if (recordReq) {
    dashboardApi.recordActionBrowse(recordReq);
  }
  const a = window.document.createElement('a');
  a.style.display = 'none';
  a.href = `mailto: ${email}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const throttle = (func: any, delay: any) => {
  let last: any, deferTimer: any;
  return (args: any) => {
    let now = Number(new Date());
    if (last && now - last < delay) {
      clearTimeout(deferTimer);
      deferTimer = setTimeout(() => {
        last = now;
        func(args);
      }, delay);
    } else {
      last = now;
      func(args);
    }
  };
};

// 时间戳 转 时间“”

export const timestampToTime = (time: any, type: any = 'date') => {
  const date = new Date(time);
  const year = date.getFullYear().toString();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  if (type === 'date') {
    return `${year}-${month}-${day}`;
  }
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
export const handleDirEmail = (email: string) => {
  if (!email) return;
  const a = window.document.createElement('a');
  a.style.display = 'none';
  a.href = `mailto: ${email}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const recordAccess = (pageId: number, buttonId: number, entity: string, type = 7) => {
  dashboardApi.recordActionBrowse({
    buttonId,
    entity,
    pageId,
    type,
  });
};
